export default __webpack_public_path__ + "static/chiller_w.e4cffa70a789b32bd23d9dfca920714c.svg";